// extracted by mini-css-extract-plugin
export default {"pill":"SelectedFilters_pill__Nk8ta","brief":"SelectedFilters_brief__BsRTR"};